import axios from '../axios'

/*
 * 佣金列表
 */

export const selectByPage = (data) => {
    return axios({
        url: '/memberBalanceFlow/selectPage',
        method: 'post',
        data
    })
}




// WEBPACK FOOTER //
// ./src/http/play/balanceFlow.js